import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import { ToastViewport } from '../ui/Toast.jsx';

export const Route = createRootRouteWithContext()({
  component: Root,
});

function Root() {
  return (
    <>
      <Outlet />
      <ToastViewport />
    </>
  );
}
